module.exports = __webpack_public_path__ + "static/img/dialog-bg-EN.b54d09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/dialog-bg-EN.png
// module id = duce
// module chunks = 1